var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShadedQ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 459,
    height: 524,
    viewBox: "0 0 459 524",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M348.802 524L282.064 443.918C263.595 448.542 244.707 450.854 225.399 450.854C184.265 450.854 146.488 441.186 112.07 421.848C77.6515 402.511 50.3685 375.817 30.2211 341.767C10.0737 307.296 0 268.411 0 225.112C0 182.233 10.0737 143.769 30.2211 109.718C50.3685 75.2475 77.6515 48.3433 112.07 29.006C146.488 9.66866 184.265 0 225.399 0C266.953 0 304.729 9.66866 338.728 29.006C373.147 48.3433 400.22 75.2475 419.947 109.718C440.095 143.769 450.169 182.233 450.169 225.112C450.169 264.207 441.774 299.939 424.984 332.308C408.615 364.257 386.159 390.32 357.616 410.498L458.353 524H348.802ZM90.6633 225.112C90.6633 254.538 96.3298 280.391 107.663 302.671C118.996 324.951 134.736 342.187 154.883 354.378C175.45 366.148 198.956 372.034 225.399 372.034C251.843 372.034 275.138 366.148 295.285 354.378C315.433 342.187 331.173 324.951 342.506 302.671C353.839 280.391 359.505 254.538 359.505 225.112C359.505 195.686 353.839 170.042 342.506 148.183C331.173 125.903 315.433 108.878 295.285 97.1071C275.138 85.3365 251.843 79.4513 225.399 79.4513C198.956 79.4513 175.45 85.3365 154.883 97.1071C134.736 108.878 118.996 125.903 107.663 148.183C96.3298 170.042 90.6633 195.686 90.6633 225.112Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadedQ);
export default __webpack_public_path__ + "static/media/shadedQ.fb5b9c1d132aea4b39247f60d68ac054.svg";
export { ForwardRef as ReactComponent };